import * as React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Checkbox } from "../../../../components/ui/checkbox";
import { Label } from "../../../../components/ui/label";
import {
  Select, SelectTrigger, SelectValue, SelectContent,
  SelectItem, SelectGroup, SelectLabel,
} from "../../../../components/ui/select";
import { limitMotorTruckCargoOptions, mtcDeductableLimitOptions } from "data"; // your data module

export function MTCSection() {
  const { control, watch, setValue } = useFormContext();
  const hasMTC = watch("step8.motor_truck_cargo");

  const c8 = watch("step8.carrier");

  const carriers = (c8 ?? []).map((s) => (s ?? ""));
  const hasProg = carriers.includes("Progressive");
  const hasAccelerant = carriers.includes("Accelerant");
  const hasNirvana = carriers.includes("Nirvana");

  // Business rule: if MTC is selected, require a positive limit.
  // We hide the "No, Excluded" (value === "0") option from the list to avoid contradiction.
  const mtcLimitOptions = React.useMemo(
    () => limitMotorTruckCargoOptions.filter((o) => o.value !== "0"),
    []
  );

  return (
    <div className="space-y-3 my-1 rounded-lg border p-4">
      <div className="flex items-center gap-3">
        <Controller
          control={control}
          name="step8.motor_truck_cargo"
          render={({ field }) => (
            <Checkbox
              id="cov-mtc"
              checked={!!field.value}
              onCheckedChange={(v) => {
                field.onChange(v);
                setValue("step8.motor_truck_cargo_limit", v ? "unselected" : undefined);
              }}
            />
          )}
        />
        <Label htmlFor="cov-mtc" className="cursor-pointer">
          Motor Truck Cargo (MTC)
        </Label>
      </div>

      {hasMTC && (
        <div className="space-y-2">
          <Label>
            Limit-Motor Truck Cargo <span className="text-red-600">*</span>
          </Label>
          <Controller
            control={control}
            name="step8.motor_truck_cargo_limit"
            render={({ field, fieldState }) => (
              <>
                <Select
                  value={(field.value) ?? "unselected"}
                  onValueChange={field.onChange}
                  onOpenChange={() => field.onChange(field.value)}
                >
                  <SelectTrigger className="w-full !h-10 py-2 px-3">
                    <SelectValue placeholder="Please select an option" />
                  </SelectTrigger>
                  <SelectContent className="max-h-60 overflow-y-auto">
                    <SelectGroup>
                      <SelectLabel>Limits</SelectLabel>
                      <SelectItem value="unselected">Please select an option</SelectItem>
                      {mtcLimitOptions.map((o) => (
                        // Store label for visual parity; switch to o.value if you prefer numeric strings
                        <SelectItem key={o.value} value={o.value}>
                          {o.label}
                        </SelectItem>
                      ))}
                    </SelectGroup>
                  </SelectContent>
                </Select>
                {fieldState.error && (
                  <p className="text-xs text-red-600 mt-1">{fieldState.error.message}</p>
                )}
              </>
            )}
          />
        </div>
      )}

      {(hasProg || hasAccelerant || hasNirvana) && hasMTC && (
        <div className="space-y-2">
          <Label>
            MTC deductible <span className="text-red-600">*</span>
          </Label>
          <Controller
            control={control}
            name="step8.mtc_deductible"
            render={({ field, fieldState }) => (
              <>
                <Select
                  value={(field.value) ?? "unselected"}
                  onValueChange={field.onChange}
                  onOpenChange={() => field.onChange(field.value)}
                >
                  <SelectTrigger className="w-full !h-10 py-2 px-3">
                    <SelectValue placeholder="Please select an option" />
                  </SelectTrigger>
                  <SelectContent className="max-h-60 overflow-y-auto">
                    <SelectGroup>
                      <SelectLabel>Limits</SelectLabel>
                      <SelectItem value="unselected">Please select an option</SelectItem>
                      {mtcDeductableLimitOptions.map((o) => (
                        // Store label for visual parity; switch to o.value if you prefer numeric strings
                        <SelectItem key={o.value} value={o.value}>
                          {o.label}
                        </SelectItem>
                      ))}
                    </SelectGroup>
                  </SelectContent>
                </Select>
                {fieldState.error && (
                  <p className="text-xs text-red-600 mt-1">{fieldState.error.message}</p>
                )}
              </>
            )}
          />
        </div>
      )}
    </div>
  );
}
